import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  MenuItem,
  TextField,
  SelectField,
  Dialog,
  FlatButton
} from 'material-ui'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import {
  HIDE_LOADER,
  submitAgentDetail,
  deleteUserRoles
} from '../../actions/userManagement'
import Constants from './contants'
import CommonConstants from '../../utils/CommonConstants'
import CommonLoader from '../../components/CommonLoader/CommonLoader'
import ConfirmationDialog from '../../components/Dialog/Dialog'

if (process.env.WEBPACK) {
  // eslint-disable-next-line global-require
  require('./style.css')
}

class UserDetails extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showLoader: false,
      isEmailInvalid: false,
      isNameInvalid: false,
      isPhoneInvalid: false,
      isEmployeeCodeInvalid: false,
      requiredErr: '',
      initialUserRoles: [],
      userDialogDetail: {
        id: null,
        name: '',
        email: '',
        role: [],
        manager: '',
        employeeCode: '',
        mobileNumber: '',
        branch: ''
      },
      isOpenConfirmDialogFlag: false,
      existingUserDetails: { userId: null, id: null },
      newUserData: null
    }
  }

  componentWillUnmount() {
    this.setState({
      initialUserRoles: [],
      userDialogDetail: {
        id: null,
        name: '',
        email: '',
        role: [],
        manager: '',
        designation: '',
        employeeCode: '',
        mobileNumber: '',
        branch: ''
      }
    })
  }

  componentWillReceiveProps(nextProps) {
    const { userData, userUpdationSuccess, open } = nextProps || {}
    const {
      userDialogDetail: { email, name, manager, role }
    } = this.state
    if (
      userUpdationSuccess === 'success' ||
      userUpdationSuccess === 'failure'
    ) {
      this.props.onRequestClose()
    }
    if (!open) {
      this.props.dispatch({
        type: HIDE_LOADER
      })
      this.setState({
        showLoader: false,
        isEmailInvalid: false,
        isNameInvalid: false,
        isPhoneInvalid: false,
        isEmployeeCodeInvalid: false,
        requiredErr: '',
        userDialogDetail: {
          id: null,
          name: '',
          email: '',
          role: [],
          manager: '',
          employeeCode: '',
          mobileNumber: '',
          branch: ''
        }
      })
    }
    if (userData && userData.id) {
      const {
        email: userEmail = '',
        name: userName = '',
        parentId,
        id,
        userId,
        employeeCode
      } = userData
      const tempRole = []
      userData.user &&
        userData.user.userRoles &&
        userData.user.userRoles.forEach(roleValue => {
          tempRole.push(roleValue.role.name)
        })
      this.setState(state => ({
        ...state,
        initialUserRoles: tempRole,
        userDialogDetail: {
          ...state.userDialogDetail,
          email: email || userEmail,
          name: name || userName,
          manager: manager || parentId,
          role: role.length ? role : tempRole,
          id,
          userId,
          employeeCode
        }
      }))
    }
  }

  handleChangeAgentValue = (value, key) => {
    const currentUser = this.state.userDialogDetail
    currentUser[key] = value
    if (key === 'email') {
      this.setState({
        isEmailInvalid: !Constants.isEmailValid(
          this.state.userDialogDetail.email
        )
      })
    }
    if (key === 'employeeCode') {
      const regex = /^[0-9]*$/ // Regular expression for integers only
      this.setState({
        isEmployeeCodeInvalid: !regex.test(value)
      })
    }
    if (key === 'name') {
      this.setState({
        isNameInvalid: !Constants.isValidName(this.state.userDialogDetail.name)
      })
    }
    this.setState({
      userDialogDetail: { ...currentUser }
    })
  }

  managerMenuItems() {
    const { userId } = this.state
    const { managerList } = this.props
    const filteredList =
      (managerList &&
        managerList.filter(manager => !userId || userId !== manager.userId)) ||
      []
    return (
      filteredList
        // eslint-disable-next-line no-confusing-arrow
        .sort((a, b) =>
          a.name.toUpperCase() > b.name.toUpperCase()
            ? 1
            : b.name.toUpperCase() > a.name.toUpperCase()
              ? -1
              : 0
        )
        .map(name => (
          <MenuItem
            key={name.id}
            value={name.userId}
            primaryText={`${name.employeeCode ? `${name.employeeCode} - ` : ''} ${name.name}`}
          />
        ))
    )
  }

  rolesMenuItems = () => {
    const rolesToShow = []
    Object.values(CommonConstants.rolesUserManagement).forEach(role => {
      rolesToShow.push(<MenuItem key={role} value={role} primaryText={role} />)
    })
    return rolesToShow
  }

  nextClick = () => {
    const {
      userDialogDetail,
      isEmailInvalid,
      isNameInvalid,
      isEmployeeCodeInvalid,
      initialUserRoles
    } = this.state

    const { submitAgentDetail, userInfo, deleteUserRoles } = this.props
    const {
      userId,
      name,
      email,
      manager,
      role: roles,
      employeeCode
    } = userDialogDetail || {}
    const rolesToDelete = initialUserRoles.filter(role => !roles.includes(role))

    let errFields = ''
    if (!name) {
      errFields += 'name'
    }
    if (!email) {
      errFields += `${errFields ? ',' : ''} email`
    }
    if (!manager) {
      errFields += `${errFields ? ',' : ''} manager`
    }
    if (!roles.length) {
      errFields += `${errFields ? ',' : ''} roles`
    }
    if (!employeeCode) {
      errFields += `${errFields ? ',' : ''} employee Code`
    }

    if (errFields) {
      this.setState({ requiredErr: `Please add values in ${errFields} fields` })
    } else if (!isEmailInvalid && !isNameInvalid && !isEmployeeCodeInvalid) {
      this.setState({ requiredErr: '' })
      if (rolesToDelete.length > 0) {
        deleteUserRoles(userId, rolesToDelete)
      }

      const newUserData = { ...userDialogDetail }
      submitAgentDetail({
        user: userDialogDetail,
        userInfo,
        companyId: Constants.companyId.housing,
        sendUserDetailsIfDuplicate: true
      }).then(response => {
        if (response && response.status === 409) {
          const existingUserData = response.data && response.data.data

          this.setState({
            existingUserDetails: existingUserData,
            newUserData: newUserData,
            isOpenConfirmDialogFlag: true
          })
        } else {
          this.props.onRequestClose()
        }
      })
    }
  }

  handleConfirmDialogClose = () => {
    this.setState({
      isOpenConfirmDialogFlag: false,
      existingUserDetails: { userId: null, id: null },
      newUserData: null
    })
  }

  handleConfirmDialogSubmit = () => {
    const { newUserData, existingUserDetails } = this.state
    const { submitAgentDetail, userInfo } = this.props
    const updatedUserData = {
      ...newUserData,
      id: existingUserDetails.id,
      userId: existingUserDetails.userId,
      email: newUserData.email,
      employeeCode: newUserData.employeeCode,
      name: newUserData.name,
      role: newUserData.role,
      manager: newUserData.manager
    }

    this.setState({
      isOpenConfirmDialogFlag: false,
      existingUserDetails: { userId: null, id: null },
      newUserData: null
    })

    this.props.onRequestClose()

    submitAgentDetail({
      user: updatedUserData,
      userInfo,
      sendUserDetailsIfDuplicate: true
    })
  }

  getDialogActions = () => (
    <React.Fragment>
      <FlatButton label='Next' primary onClick={() => this.nextClick()} />
      <FlatButton
        label='Cancel'
        primary
        onClick={this.props.handleAssignAgentDialog}
      />
    </React.Fragment>
  )

  getErrorMsg = ({ errMsg } = {}) => {
    return errMsg ? <div style={{ color: 'red' }}>{errMsg}</div> : null
  }

  render() {
    const {
      userDialogDetail,
      isNameInvalid,
      isEmailInvalid,
      requiredErr,
      isEmployeeCodeInvalid,
      isOpenConfirmDialogFlag
    } = this.state
    const { id, name, email, manager, role, employeeCode } =
      userDialogDetail || {}
    const { open, onRequestClose, showLoader } = this.props
    return (
      <div>
        <Dialog
          title='User Details'
          actions={this.getDialogActions()}
          modal={false}
          open={open}
          onRequestClose={onRequestClose}
        >
          <div>
            <div>
              <TextField
                fullWidth
                floatingLabelText='Agent Name'
                value={name}
                onChange={event => {
                  this.handleChangeAgentValue(event.target.value, 'name')
                }}
                required
              />
              {this.getErrorMsg({
                errMsg: isNameInvalid ? 'Enter valid name' : ''
              })}
            </div>
            <div>
              <TextField
                fullWidth
                floatingLabelText='Employee Code'
                value={employeeCode}
                onChange={event => {
                  this.handleChangeAgentValue(
                    event.target.value,
                    'employeeCode'
                  )
                }}
                maxLength={10}
                required
              />
              {this.getErrorMsg({
                errMsg: isEmployeeCodeInvalid ? 'Enter valid Employee Code' : ''
              })}
            </div>
            <div>
              <TextField
                fullWidth
                floatingLabelText='Email'
                value={email}
                disabled={id}
                onChange={event => {
                  this.handleChangeAgentValue(event.target.value, 'email')
                }}
                required
              />
              {this.getErrorMsg({
                errMsg: isEmailInvalid ? 'Enter valid email' : ''
              })}
            </div>
            <div>
              <SelectField
                fullWidth
                floatingLabelText='Manager Name'
                value={manager || null}
                onChange={(_, __, value) => {
                  this.handleChangeAgentValue(value, 'manager')
                }}
                required
              >
                {this.managerMenuItems()}
              </SelectField>
            </div>
            <div>
              <SelectField
                fullWidth
                multiple
                floatingLabelText='Role'
                value={role.length ? role : null}
                onChange={(_, __, value) => {
                  this.handleChangeAgentValue(value, 'role')
                }}
                required
              >
                {this.rolesMenuItems()}
              </SelectField>
            </div>
          </div>
          {this.getErrorMsg({ errMsg: requiredErr })}
          {showLoader && <CommonLoader propStyle={Constants.style} />}
        </Dialog>
        <ConfirmationDialog
          title='Company User Already Registered'
          dialogContent='This User already registered, do you want to provide RCM access?'
          handleOpen={isOpenConfirmDialogFlag}
          handleClose={this.handleConfirmDialogClose}
          handleSubmit={this.handleConfirmDialogSubmit}
        />
      </div>
    )
  }
}
const mapStateToProps = state => ({
  userInfo: state.userInfo,
  managerList: state.managerList,
  userUpdationSuccess: state.userUpdationSuccess,
  showLoader: state.showLoader
})
const mapDispatchToProps = dispatch => {
  return {
    submitAgentDetail: bindActionCreators(submitAgentDetail, dispatch),
    deleteUserRoles: bindActionCreators(deleteUserRoles, dispatch),
    dispatch
  }
}

UserDetails.propTypes = {
  showLoader: PropTypes.boolean,
  userInfo: PropTypes.object,
  open: PropTypes.func,
  onRequestClose: PropTypes.func,
  submitAgentDetail: PropTypes.func,
  deleteUserRoles: PropTypes.func,
  managerList: PropTypes.object,
  handleAssignAgentDialog: PropTypes.func,
  dispatch: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(UserDetails)



/** WEBPACK FOOTER **
 ** ./src/containers/UserManagement/UserDetails.js
 **/